<template>
  <div v-if="block.type">
    <div v-if="getInputSectionsFromDefinitionsByBlockType().length === 0">
      This block doesn't have any configuration
    </div>
    <div
      v-for="(section, index) in getInputSectionsFromDefinitionsByBlockType()"
      :key="'section-' + index"
    >
      <div class="section-title">{{ section.title }}</div>
      <!-- NORMAL -->
      <div v-if="section.type === 'normal'">
        <DynamicInputRenderer
          v-for="(input, index2) in section.inputs"
          :key="'input-nor-' + index2"
          :block="block"
          :input="input"
          :parent="block.config"
          :pathprefix="['config']"
          @l-change="onInputChange($event, ['config', input.property], input)"
        ></DynamicInputRenderer>
      </div>
      <!-- ARRAY -->
      <div v-if="section.type === 'array'">
        <draggable
          tag="div"
          :list="block.config[section.parent]"
          handle=".handle-depth-1"
          @end="
            onDragEnd();
            saveBlockConfig(block);
          "
          v-if="!hide"
          ghostClass="ghost"
        >
          <WrappedDynamicInput
            v-for="(item, index) in block.config[section.parent]"
            :key="'ak-arr-' + index"
            :block="block"
            :section="section"
            :parent="item"
            :index="index"
            :items="block.config[section.parent]"
            :pathprefix="['config', section.parent]"
            :depth="1"
            @deep-change="
              onInputChange($event.value, [
                'config',
                section.parent,
                index,
                ...$event.path,
              ])
            "
            @l-splice="onSplice($event.index, [...$event.path])"
            @l-add-new="
              onAddNew($event.item, [
                'config',
                section.parent,
                index,
                ...$event.path,
              ])
            "
          ></WrappedDynamicInput>
        </draggable>
        <v-btn
          @click="
            onAddNew(cloneJson(section.newItem), ['config', section.parent])
          "
          v-if="!block.hasOwnProperty('disableInputs')"
          small
          >{{ section.newItemButtonText }}</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import projectMixin from "../project-mixin";
import WrappedDynamicInput from "./WrappedDynamicInput";
import DynamicInputRenderer from "./DynamicInputRenderer";

export default {
  props: ["block"],
  name: "Block",
  components: {
    DynamicInputRenderer,
    WrappedDynamicInput,
  },
  mixins: [projectMixin],
  data() {
    return {
      hide: false,
    };
  },
  watch: {
    "block.config": {
      deep: true,
      handler: function (val) {
        this.selectedPageBlocks.map((block) => {
          if (block.referencedBlockId == this.block.id) block.config = val;
        });
      },
    },
  },
  methods: {
    onDragEnd() {
      // force-render block inputs after drag end because there is a bug that prevents re-render when list mutates.
      this.hide = true;
      setTimeout(() => {
        this.hide = false;
      }, 10);
    },
    onInputChange(value, prop) {
      this.UPDATE_BLOCK_PROP({ id: this.block.id, prop, value });
      // this.saveBlockDebounced(this.block);
    },
    onSplice(index, prop) {
      // console.log("onSplice index", index);
      // console.log("onSplice prop", prop);
      // const targetId = get(this.block, prop)[index].id;
      // this.DELETE_BLOCK_LIST_ITEM({
      //   id: this.block.id,
      //   prop,
      //   index,
      //   targetId,
      // });
      this.DELETE_BLOCK_LIST_ITEM({ id: this.block.id, prop, index });
    },
    onAddNew(item, prop) {
      this.ADD_BLOCK_LIST_ITEM({
        id: this.block.id,
        prop,
        item: { ...item, id: this.randomId() },
      });
    },
    cloneJson(item) {
      return JSON.parse(JSON.stringify(item));
    },
  },
};
</script>

<style scoped>
.section-title {
  font-size: 15px;
  font-weight: bold;
}
</style>